import { Configuration, ConfigurationParameters, ErrorContext, FetchParams, Middleware, ResponseContext } from './data';
import { msalInstance } from '.';
import { loginRequest } from './authConfig';

const configParams: ConfigurationParameters = {
    basePath: process.env.REACT_APP_API_URL,
    accessToken: async (s,scopes)=>{
      const account = msalInstance.getActiveAccount();
      if (!account) {
          throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
      }
  
      const response = await msalInstance.acquireTokenSilent({
          ...loginRequest,
          account: account
      });
  
//console.log(response.accessToken);

      // const headers = new Headers();
      return 'Bearer ' + response.accessToken;
  },
  };
  
  export const apiConfiguration = new Configuration(configParams);